import DOMPurify from 'dompurify';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      sanitize: (input: string) => DOMPurify.sanitize(input, {ALLOWED_TAGS: []}),
    },
  };
});